export const buildMembershipsFilterGroups = (venueOwnerships = [], filterOptions = {}) => [
  ...(venueOwnerships.length > 0 ? [{
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_ownership_id',
        label: 'Venue',
        type: 'checkbox',
        options: venueOwnerships.map((vo) => ({ value: String(vo.id), label: vo.name || vo.venue_name || `Venue ${vo.id}` })),
      },
    ],
  }] : []),
  {
    id: 'sold_by',
    label: 'Sold By',
    filters: [
      {
        id: 'sold_by_team_membership_id',
        label: 'Sold By',
        type: 'search',
        options: (filterOptions.seller_options || []).map(o => ({
          value: o.value,
          label: o.label,
        })),
      },
    ],
  },
  {
    id: 'membership_details',
    label: 'Membership Details',
    filters: [
      {
        id: 'membership_product',
        label: 'Membership Product',
        type: 'checkbox',
        options: (filterOptions.product_options || []).map(o => ({
          value: o.value,
          label: o.label,
        })),
      },
      {
        id: 'status',
        label: 'Status',
        type: 'checkbox',
        options: [
          { value: 'active', label: 'Active' },
          { value: 'trialing', label: 'Trialing' },
          { value: 'past_due', label: 'Past Due' },
          { value: 'canceled', label: 'Canceled' },
          { value: 'paused', label: 'Paused' },
          { value: 'incomplete', label: 'Incomplete' },
          { value: 'unpaid', label: 'Unpaid' },
        ],
      },
      {
        id: 'interval',
        label: 'Interval',
        type: 'checkbox',
        options: [
          { value: 'month', label: 'Month' },
          { value: 'year', label: 'Year' },
        ],
      },
      {
        id: 'member_name_search',
        label: 'Member Name',
        type: 'search',
        options: [],
      },
    ],
  },
];
